import { useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AtlasCard } from "./AtlasCard";
import { ProfessionCard } from "./ProfessionCard";
import { PushCard } from "./PushCard";
import { AlertPrefsCard } from "./AlertPrefsCard";
import { CalendarSyncCard } from "./CalendarSyncCard";
import { PhoneNudge } from "@/components/contacts/PhoneNudge";
import { DeleteAccountCard } from "./DeleteAccountCard";

export const SettingsDialog = ({ open, onOpenChange }) => {
  // "Open my contact card" lives in the bottom bar, so step out of Settings first
  useEffect(() => {
    const close = () => onOpenChange(false);
    window.addEventListener("bl:open-card", close);
    return () => window.removeEventListener("bl:open-card", close);
  }, [onOpenChange]);
  return (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-[#111827] border-white/10 text-slate-100 max-w-md max-h-[90vh] overflow-y-auto" data-testid="settings-dialog">
      <DialogHeader><DialogTitle className="font-display">Settings</DialogTitle></DialogHeader>
      <PhoneNudge inSettings testId="settings-phone-card" />
      <PushCard />
      <AlertPrefsCard />
      <CalendarSyncCard />
      <ProfessionCard />
      <AtlasCard />
      <DeleteAccountCard />
    </DialogContent>
  </Dialog>
  );
};
